import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalyticsTracking } from '@/hooks/useAnalyticsTracking';

/**
 * Global PageViewTracker — fires a `page_view` event on every route change.
 * Mounted once in PublicLayoutWrapper.
 * 
 * Deduplicates consecutive same-path navigations.
 * Skips /topic/* paths (TopicPage handles its own tracking).
 */
export function PageViewTracker() {
  const { pathname } = useLocation();
  const { trackEvent } = useAnalyticsTracking();
  const lastPath = useRef('');

  useEffect(() => {
    if (pathname === lastPath.current) return;
    // TopicPage fires its own page_view — skip to avoid double-counting
    if (pathname.startsWith('/topic/')) return;
    lastPath.current = pathname;

    const pageType = pathname === '/' ? 'homepage'
      : pathname.match(/^\/[^/]+\/[^/]+$/) && !pathname.startsWith('/a/') ? 'expert_profile'
      : pathname.startsWith('/a/') ? 'publication'
      : pathname.startsWith('/experts') ? 'experts_list'
      : pathname.startsWith('/account') ? 'account'
      : pathname.startsWith('/admin') ? 'admin'
      : pathname.startsWith('/ajuda') || pathname.startsWith('/help') ? 'help_center'
      : pathname.startsWith('/chat') ? 'chat'
      : 'other';

    trackEvent({
      eventType: 'page_view',
      eventCategory: 'navigation',
      sourcePage: pathname,
      metadata: { pageType }
    });
  }, [pathname, trackEvent]);

  return null;
}
